import styled from '@emotion/styled';

export const CloseButton = styled('button', { label: 'CloseButton' })`
    padding: 10px;
`;

export const AffordabilityAuditTable = styled('table', { label: 'AffordabilityAuditTable' })`
    tbody {
        & > tr:nth-of-type(even){
            background-color: rgb(240,240,240);
        }
    }

`;
